export default class UserModel {
    idNUsuario: number | null;
    fkNTipoUsuario: number | null;
    fldTNombre: string | null;
    fldTLogin: string | null;
    fldTPassword: string | null;
    fldTEmail: string | null;
    fldBActivo: boolean | null;

    // Para manejar la relacion 1 a 1 Con RelacionEmpresaUsuario
    idNEmpresa: number | null;

    constructor() {
        this.idNUsuario = null;
        this.fkNTipoUsuario = null;
        this.fldTNombre = null;
        this.fldTLogin = null;
        this.fldTPassword = null;
        this.fldTEmail = null;
        this.fldBActivo = false;
        this.idNEmpresa = null;

    }
}